import { loader } from 'graphql.macro';

export const getProject = loader('./GetProject.gql');
export const setWorkstationEntitlements = loader(
  './SetWorkstationEntitlements.gql'
);

// cache busting comment hash 3657456757
